











































































































































import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import { getEquipmentUrl, getEngineName } from "../models";
import { Getter } from "vuex-class";
import { inventoryCollection } from "../db";
import EquipmentBanner from "@/components/equipment-banner.vue";

@Component({
  components: {
    EquipmentBanner,
  },
})
export default class EquipmentCard extends Vue {
  @Getter admin;

  @Prop({ required: true })
  public item: any;

  @Prop({ required: true })
  public moveUpDisabled: any;

  @Prop({ required: true })
  public index: any;

  @Emit()
  // eslint-disable-next-line @typescript-eslint/no-empty-function,@typescript-eslint/no-unused-vars
  moveUp(item, index) {}

  @Prop({ required: true })
  public moveDownDisabled: any;

  @Emit()
  // eslint-disable-next-line @typescript-eslint/no-empty-function,@typescript-eslint/no-unused-vars
  moveDown(item, index) {}

  get url() {
    if (this.admin) {
      return `/inventory/${this.item.stockNumber}/edit`;
    }
    return "/inventory/" + getEquipmentUrl(this.item);
  }

  get engine() {
    return getEngineName(this.item);
  }

  get imageUrl() {
    if (
      this.item?.imageUrl != undefined &&
      this.item?.imageUrl != ""
    ) {
      return `${this.item.imageUrl}`;
    }
    return `https://placeholder.pics/svg/500x375`;
  }

  deleteEquipment(item) {
    inventoryCollection.doc(item.id).delete();
    
  }

  visibleChange(value) {
    inventoryCollection.doc(this.item.id).update({ visible: value });
  }
}
